import * as Page404 from './Page404.css';
export default {
    Page404
};
